module.exports = __webpack_public_path__ + "img/phone.f51f1cde.svg";